import React, { useContext, useEffect } from 'react';
import { ContextBuilder } from "../../../../context/builder/reducers";
import useOnChange from '../../../../hooks/useChange';
import arrayMove from 'array-move';
import SortableList, { QUOTE_ITEM, BRAND_ITEM } from '../SortableList';

const OurClient = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                title: '',
                subTitle: '',
                quotes: [],
                brands: []
            }
            dispatch({ type: 'data', payload: { data } })
        }
    });

    let quotes = props.content.quotes || [];
    let brands = props.content.brands || [];

    const onSortEndQuote = ({ oldIndex, newIndex }) => {
        const data = state.data;
        quotes = arrayMove(quotes, oldIndex, newIndex);
        data.value[props.index].content.quotes = quotes;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const onSortEndBrand = ({ oldIndex, newIndex }) => {
        const data = state.data;
        brands = arrayMove(brands, oldIndex, newIndex);
        data.value[props.index].content.brands = brands;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const addItemQuote = () => {
        const data = state.data;
        quotes = [...quotes, { name: '', position: '', quote: '', img: null }];
        data.value[props.index].content.quotes = quotes;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const addItemBrand = () => {
        const data = state.data;
        brands = [...brands, { img: null }];
        data.value[props.index].content.brands = brands;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const deleteButtonQuoteHandler = (e) => {
        const index = e.currentTarget.getAttribute('index');
        const data = state.data;
        quotes.splice(index, 1);
        data.value[props.index].content.quotes = quotes;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const deleteButtonBrandHandler = (e) => {
        const index = e.currentTarget.getAttribute('index');
        const data = state.data;
        brands.splice(index, 1);
        data.value[props.index].content.brands = brands;
        dispatch({ type: 'data', payload: { data: data } });
    };

    return (
        <div className="our-clients">
            <h2>Our clients</h2>
            <hr/>
            <div>
                <SortableList
                    item={QUOTE_ITEM}
                    titleComponent="Quotes"
                    elements={props.content.quotes || []}
                    onChange={onChange}
                    onSortEnd={onSortEndQuote}
                    addItem={addItemQuote}
                    deleteButtonHandler={deleteButtonQuoteHandler}
                    axis="xy"
                    useDragHandle
                />
            </div>
            <div>
                <SortableList
                    item={BRAND_ITEM}
                    titleComponent="Brands"
                    elements={props.content.brands || []}
                    onChange={onChange}
                    onSortEnd={onSortEndBrand}
                    addItem={addItemBrand}
                    deleteButtonHandler={deleteButtonBrandHandler}
                    axis="xy"
                    useDragHandle
                />
            </div>
        </div>
    );
}

export default OurClient;
